<template>
  <Modal :id="'cmp-add-territory'" @cancelled="onCancel">
    <template slot="header"
      >{{$t('find_territory')}}</template
    >

    <template slot="body">
      <div class="contact-type-selection">
        <div class="contact-type">
          <input
            type="radio"
            :checked="countryType == 'territory'"
            @change="e => onChangeContactType('territory')"
            value="territory"
            name="contact"
          />
          <label for="contact" @click="e => onChangeContactType('territory')"
            >{{$t('by_territory')}}</label
          >
        </div>
        <div class="contact-type">
          <input
            type="radio"
            :checked="countryType == 'country'"
            @change="e => onChangeContactType('country')"
            value="country"
            name="contact"
          />
          <label for="contact" @click="e => onChangeContactType('country')"
            >{{$t('by_country')}}</label
          >
        </div>
      </div>
      <div class="fform-group">
        <Dropdown
          :options="countryTV"
          class="group-input m2"
          :key="'group_dropdown_company'"
          :placeholder="placeHolderText"
          v-on:selectedChange="e => onFormatChange(e)"
          :selected="countryTV.find(e => e.value == country_id)"
          box
          :listHeight="250"
        ></Dropdown>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click="onAddCountry">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
// import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from '../../../store';
// import * as ActionTypes from '../../../store/types';

// import {mapGetters, mapActions} from 'vuex';

import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from "../../../../dt-plugins/modal/modal";
import {
  createModalMixin,
  closeModal2Route,
  openModal2Route
} from "../../../../dt-plugins/modal/modal.mixin";
import { ProductsService } from "../../services/products.service";
import { createTV } from "../../../../models/text-value.model";

export default {
  props: {},
  components: {
    InputField,

    Modal
  },
  mixins: [],
  // watch: {
  //   searchString: {
  //     immediate: true,
  //     handler: function(to, from) {
  //       console.log(`searchString Change to ${to} from ${from}`);
  //     }
  //   }
  // },
  data: function() {
    return {
      territory: [],
      searchString: "",
      genreSubject$: new Subject(),
      genreSearchResult: [],

      searchSize: "single",
      countries: [],
      country_id: 0,
      territory_id: 0,
      countryType: "country"
    };
  },
  mounted: async function() {
    const territoryData = await ProductsService.getCountryFormData(
      this.external_id
    );
    this.territory = territoryData.data.territories;
    console.log("::::::", this, this.territory);
    this.countries = territoryData.data.countries;

    // Artist Subscription
    // subscribeSubject(this, this.genreSubject$, searchString => {

    //     releaseService.searchUnrelatedGenres(this.external_id,searchString).then(res=>{
    //         console.warn(searchString,res);
    //         this.genreSearchResult=res.data.unrelated_genres
    //     })

    //   })
  },
  computed: {
    countryTV: function() {
      if (this.countryType == "country") {
        return createTV(this.countries, "country_fullname", "country_id");
      } else {
        return createTV(this.territory, "territory_name", "territory_id");
      }
    },

    placeHolderText:function(){
      if (this.countryType == "country") {
        return 'By Country';
      } else {
        return 'By Territory';
      }
    },
    hRowMarginRight: function() {
      if (this.territory.length > 380 / 28) {
        return "28px";
      }
    },

    external_id: function() {
      return this.$route.query.external_id;
    },

    territoryList: function() {
      if (this.searchString.length > 0) {
        return this.genreSearchResult;
      } else {
        return this.territory;
      }
    }
  },
  methods: {
    onChangeContactType: function(type) {
      this.countryType = type;
      // this.company = {};
      // this.person = {};

      //await wait(20);

      // this.company = createCompany();
      // this.person = createPerson();

      // console.log({
      //   company: this.company,
      //   person: this.person,
      // });
    },

    onFormatChange: function(value) {
      console.log("VALUE", value);
      // if(this.countryType=="country")
      // {
      this.country_id = value.value;
      // }
      // else
      // {
      //   this.territory_id=value.value
      // }
    },

    // onRowClicked: async function(item) {
    //   console.log(item);

    //   this.$emit("create",payload)

    // },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    // onAddPersonClicked: function(e) {
    //   // this.$router.push({
    //   //   ...this.$route,
    //   //   query: {
    //   //     ...this.$route.query,
    //   //     modal2: 'add_person'
    //   //   }
    //   // });
    //   openModal2Route(this, 'add_person');

    //   // this.addPersonModalContainer = true;
    //   // waitForAnimation(() => {
    //   //   this.addPersonModal = true;
    //   // });
    // },
    // onAddPersonCancelled: function() {
    //   // this.$router.push({
    //   //   query: {
    //   //     ...this.$route.query,
    //   //     modal2: undefined
    //   //   }
    //   // });
    //   closeModal2Route(this);
    //   // this.addPersonModal = false;

    //   // waitForAnimation(() => {
    //   //   this.addPersonModalContainer = false;
    //   // });
    // },
    // onAddCompanyClicked: function() {
    //   openModal2Route(this, 'add_company');
    //   // this.addCompanyModalContainer = true;
    //   // waitForAnimation(() => {
    //   //   this.addCompanyModal = true;
    //   // });
    // },
    // onAddCompanyCancelled: function() {
    //   closeModal2Route(this);
    //   // this.addCompanyModal = false;

    //   // waitForAnimation(() => {
    //   //   this.addCompanyModalContainer = false;
    //   // });
    // },

    onAddCountry: function() {
      let payload = {};
      if (this.countryType == "country") {
        payload = {
          name: "country",
          product_id: this.external_id,
          country_id: this.country_id
        };
      } else {
        payload = {
          name: "territory",
          product_id: this.external_id,
          territory_id: this.country_id
        };
      }

      this.$emit("create", payload);
    }
  }
};
</script>

<style lang="scss" scoped>
.cmp-add-territory {
  .dt-modal--body {
    margin-left: 0px;
  }

  .contact-type-selection {
    display: flex;
    flex-direction: column;
    padding: 0px;
    margin-bottom: 10px;
    .contact-type {
      flex: 1;
      display: flex;
      margin: 4px 0px;

      input {
        margin: auto 0;
      }
      label {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
}
</style>
